import { useEffect, useState } from "react";

const navLinks = [
  { label: "首页", href: "#home" },
  { label: "核心功能", href: "#features" },
  { label: "热门漫画", href: "#comics" },
  { label: "主题分类", href: "#categories" },
  { label: "使用教程", href: "#how" },
  { label: "常见问题", href: "#faq" },
  { label: "联系反馈", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => setOpen(false);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 shadow-soft backdrop-blur-md"
          : "bg-transparent"
      }`}
    >
      <nav
        className={`mx-auto flex h-16 max-w-7xl items-center justify-between px-4 transition-all duration-300 md:h-20 md:px-6 ${
          scrolled ? "" : "py-1"
        }`}
      >
        <a
          href="#home"
          className="flex items-center gap-2.5"
          aria-label="洒洒漫画网 首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-2-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-xl font-bold tracking-wide text-foreground-900">
            洒洒<span className="text-primary-600">漫画网</span>
          </span>
        </a>

        <div className="hidden items-center gap-7 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="#contact"
            className="rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            立即体验
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 lg:hidden"
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-3">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={close}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={close}
              className="mt-2 rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-semibold text-background-50"
            >
              立即体验
            </a>
          </div>
        </div>
      )}
    </header>
  );
}